import type { HelpFile } from '../../types/help'
import { TagInputTestIds } from '../../../testids/TagInputTestIds'

export const tagInputHelp: HelpFile = {
  texts: {
    [TagInputTestIds.validationError]:
      'Ein eingegebenes Tag hat die Validierung nicht bestanden — zum Beispiel Duplikat, leer oder nicht in der erlaubten Werteliste.',
    [TagInputTestIds.validationHint]:
      'Hinweis dazu, welche Werte in diesem Tag-Feld erlaubt sind.',
  },
}
